import React, { useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  DialogActions,
  Button,
  TextField,
  FormControlLabel,
  Checkbox,
  Alert,
  Box,
  Typography,
  CircularProgress,
} from "@material-ui/core";

const ModalEliminarPago = ({
  open,
  onClose,
  pago,
  factura,
  onEliminar,
  isLoading = false,
}) => {
  const [motivo, setMotivo] = useState("");
  const [enviarCorreo, setEnviarCorreo] = useState(false);
  const [error, setError] = useState("");

  const handleClose = () => {
    setMotivo("");
    setEnviarCorreo(true);
    setError("");
    onClose();
  };

  const handleEliminar = () => {
    // Validaciones
    if (!motivo.trim()) {
      setError("El motivo es obligatorio");
      return;
    }

    if (motivo.length > 500) {
      setError("El motivo no puede exceder 500 caracteres");
      return;
    }

    setError("");
    onEliminar({
      id: pago.id,
      motivo: motivo.trim(),
      enviarCorreo,
    });
  };

  const formatCurrency = (value) => {
    return new Intl.NumberFormat("es-CL", {
      style: "currency",
      currency: "CLP",
      minimumFractionDigits: 0,
    }).format(value);
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      fullWidth
      maxWidth="sm"
      aria-labelledby="eliminar-pago-dialog"
    >
      <DialogTitle id="eliminar-pago-dialog">Eliminar Pago</DialogTitle>

      <DialogContent>
        <Box mb={2}>
          <Alert severity="warning">
            <Typography variant="body2">
              <strong>¿Estás seguro de eliminar este pago?</strong>
            </Typography>
            <Typography variant="body2" style={{ marginTop: 8 }}>
              • <strong>Valor:</strong> {formatCurrency(pago?.valorPesos || 0)}
            </Typography>
            <Typography variant="body2">
              • <strong>Fecha:</strong> {pago?.fechaPago}
            </Typography>
            <Typography variant="body2">
              • <strong>Método:</strong> {pago?.metodoPago}
            </Typography>
            <Typography variant="body2">
              • <strong>Factura:</strong> N° {factura?.folio}
            </Typography>
          </Alert>
        </Box>

        <TextField
          label="Motivo de eliminación *"
          multiline
          rows={3}
          fullWidth
          variant="outlined"
          value={motivo}
          onChange={(e) => setMotivo(e.target.value)}
          error={!!error}
          helperText={error || `${motivo.length}/500 caracteres`}
          margin="normal"
          placeholder="Describe el motivo de la eliminación..."
        />

        <Box mt={2}>
          <FormControlLabel
            control={
              <Checkbox
                checked={enviarCorreo}
                onChange={(e) => setEnviarCorreo(e.target.checked)}
                color="primary"
              />
            }
            label="Enviar notificación por correo al cliente"
          />
        </Box>

        {enviarCorreo && (
          <Box mt={1}>
            <Alert severity="info">
              <Typography variant="body2">
                Se enviará un correo al cliente notificando la eliminación del
                pago y el nuevo estado de la factura.
              </Typography>
            </Alert>
          </Box>
        )}
      </DialogContent>

      <DialogActions>
        <Button onClick={handleClose} disabled={isLoading}>
          Cancelar
        </Button>
        <Button
          onClick={handleEliminar}
          color="primary"
          variant="contained"
          disabled={isLoading || !motivo.trim()}
          startIcon={isLoading && <CircularProgress size={16} />}
        >
          {isLoading ? "Eliminando..." : "Eliminar Pago"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ModalEliminarPago;
